<template>
  <div class="log">
    <FilterForm :fields="fields" @submit="filter"/>
    <BasicTable :tableData="[]" />
  </div>
</template>

<script>
import FilterForm from '@/components/filterForm/filterForm.component';
import BasicTable from '@/components/table/table.component';
import { LogService } from '../../service/log.service';
  const fields = [
    { type: 'input', key: 'adminId', name: '管理员ID' },
  ]
  export default {
    name: 'log',
    data() {
      return {
        fields,
      }
    },
    components: { FilterForm, BasicTable },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        await LogService.getLog();
      },
      async filter () {
        await LogService.getLog();
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>